import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { GalleryPage } from './pages/GalleryPage';
import { SettingsPage } from './pages/SettingsPage';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
function GlobalLogin({
  onLogin
}: {
  onLogin: () => void;
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (username === 'kasspi' && password === '2368') {
      onLogin();
    } else {
      setError('Nesprávné údaje.');
    }
  };
  return <div className="fixed inset-0 z-[9999] bg-off-white flex items-center justify-center px-6" data-id="element-0" data-mp="28u5z6q8t7bef">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full border border-mist" data-id="element-1" data-mp="23vkuoemiy5k6">
        <div className="flex justify-center mb-6" data-id="element-2" data-mp="3mjq1fdddwou0">
          <div className="bg-mist p-4 rounded-full text-blue-medium" data-id="element-3" data-mp="3rbrakqf99zft">
            <LockIcon className="w-8 h-8" data-id="element-4" data-mp="3relv0hy9rk98" />
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-navy-deep text-center mb-2" data-id="element-5" data-mp="5gbv0xpxarn">
          Vstup pro pozvané
        </h1>
        <p className="text-navy-deep/60 text-center mb-8 text-sm" data-id="element-6" data-mp="2zng1ikd20ksx">
          Projekt je v přípravě. Pro náhled se prosím přihlaste.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-7" data-mp="38li77d7qg1mj">
          <input type="text" placeholder="Jméno" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-mist outline-none focus:border-blue-medium transition-all" data-id="element-8" data-mp="38o4ct7b2c724" />
          <input type="password" placeholder="Heslo" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-mist outline-none focus:border-blue-medium transition-all" data-id="element-9" data-mp="swglpsiqd8r8" />
          {error && <p className="text-red-500 text-sm text-center" data-id="element-10" data-mp="85l1granwy97">{error}</p>}
          <button type="submit" className="w-full bg-blue-medium text-white py-3 rounded-lg font-medium hover:bg-blue-sky transition-colors" data-id="element-11" data-mp="86cqtkdo1zr1">
            Vstoupit
          </button>
        </form>
      </motion.div>
    </div>;
}
export function App() {
  const [isAuthorized, setIsAuthorized] = useState(() => localStorage.getItem('fch_global_authorized') === 'true');
  const handleAuthorize = () => {
    setIsAuthorized(true);
    localStorage.setItem('fch_global_authorized', 'true');
  };
  // Vstupní restrikce dočasně vypnuta – web je veřejně přístupný.
  // if (!isAuthorized) {
  //   return <GlobalLogin onLogin={handleAuthorize} />
  // }
  return <div className="w-full min-h-screen bg-off-white flex flex-col" data-id="element-12" data-mp="18boiuhysu3uu">
      <Navigation data-id="element-13" data-mp="1d59kql3ijhzb" />
      <div className="flex-grow" data-id="element-14" data-mp="1d5sq72bz8dwg">
        <Routes data-id="element-15" data-mp="yflf57oatx5s">
          <Route path="/" element={<Home data-id="element-17" data-mp="ygwkvd1b1ezj" />} data-id="element-16" data-mp="yg3lix4odrrf" />
          <Route path="/galerie" element={<GalleryPage data-id="element-19" data-mp="13eoecbhll95u" />} data-id="element-18" data-mp="yheowvu7kxi0" />
          <Route path="/nastaveni" element={<SettingsPage data-id="element-21" data-mp="13ey4bz2n7gbj" />} data-id="element-20" data-mp="13dwutz19z1vx" />
        </Routes>
      </div>
      <Footer data-id="element-22" data-mp="1r3r11xr39s77" />
    </div>;
}